import React from 'react';
const AuthContext = React.createContext();

/* Prevent circular dependencies - webpack messes up the context api otherwise */
export default AuthContext;
